import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faTimes, faSave } from '@fortawesome/free-solid-svg-icons';

const TimesheetPreferencesModal = ({
    showPreferences,
    setShowPreferences,
    userPreferences,
    setUserPreferences,
    resetPreferences,
    savePreferences
}) => {
    if (!showPreferences) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(0, 0, 0, 0.8)',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            zIndex: 1001,
            padding: '2rem'
        }}>
            <div style={{
                background: 'var(--color-surface)',
                borderRadius: 'var(--border-radius-xl)',
                maxWidth: '700px',
                width: '100%',
                maxHeight: '90vh',
                overflowY: 'auto',
                boxShadow: 'var(--shadow-xl)'
            }}>
                {/* Header */}
                <div style={{
                    padding: '2rem 2rem 1rem',
                    borderBottom: '2px solid var(--color-light-gray)'
                }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h2 style={{ margin: 0, display: 'flex', alignItems: 'center', gap: '12px' }}>
                            <FontAwesomeIcon icon={faCog} style={{ color: '#6b7280' }} />
                            Préférences Utilisateur
                        </h2>
                        <button
                            onClick={() => setShowPreferences(false)}
                            style={{
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                fontSize: '1.5rem',
                                color: 'var(--color-text-light)',
                                padding: '8px'
                            }}
                        >
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                </div>

                {/* Form */}
                <div style={{ padding: '2rem' }}>
                    <div style={{ display: 'grid', gap: '2rem' }}>
                        {/* Display Preferences */}
                        <div>
                            <h3 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.1rem', color: 'var(--color-text)' }}>
                                🖥️ Affichage
                            </h3>
                            <div style={{ display: 'grid', gap: '1rem' }}>
                                {/* Default View */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '0.5rem',
                                        fontWeight: '600',
                                        fontSize: '0.9rem'
                                    }}>
                                        Vue par défaut
                                    </label>
                                    <select
                                        value={userPreferences.defaultView}
                                        onChange={(e) => setUserPreferences({ ...userPreferences, defaultView: e.target.value })}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid var(--color-light-gray)',
                                            borderRadius: 'var(--border-radius-md)',
                                            backgroundColor: 'var(--color-surface)',
                                            color: 'var(--color-text)'
                                        }}
                                    >
                                        <option value="list">📋 Liste</option>
                                        <option value="employee">👥 Par Employé</option>
                                        <option value="calendar">📅 Calendrier</option>
                                    </select>
                                </div>

                                {/* Default Date Filter */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '0.5rem',
                                        fontWeight: '600',
                                        fontSize: '0.9rem'
                                    }}>
                                        Filtre de date par défaut
                                    </label>
                                    <select
                                        value={userPreferences.defaultDateFilter}
                                        onChange={(e) => setUserPreferences({ ...userPreferences, defaultDateFilter: e.target.value })}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid var(--color-light-gray)',
                                            borderRadius: 'var(--border-radius-md)',
                                            backgroundColor: 'var(--color-surface)',
                                            color: 'var(--color-text)'
                                        }}
                                    >
                                        <option value="today">Aujourd'hui</option>
                                        <option value="week">Cette semaine</option>
                                        <option value="month">Ce mois</option>
                                        <option value="all">Tout afficher</option>
                                    </select>
                                </div>

                                {/* Default Theme */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        marginBottom: '0.5rem',
                                        fontWeight: '600',
                                        fontSize: '0.9rem'
                                    }}>
                                        Thème par défaut
                                    </label>
                                    <select
                                        value={userPreferences.defaultTheme}
                                        onChange={(e) => setUserPreferences({ ...userPreferences, defaultTheme: e.target.value })}
                                        style={{
                                            width: '100%',
                                            padding: '10px',
                                            border: '1px solid var(--color-light-gray)',
                                            borderRadius: 'var(--border-radius-md)',
                                            backgroundColor: 'var(--color-surface)',
                                            color: 'var(--color-text)'
                                        }}
                                    >
                                        <option value="default">🌿 Classique</option>
                                        <option value="ocean">🌊 Océan</option>
                                        <option value="sunset">🌅 Coucher de soleil</option>
                                        <option value="purple">💜 Violet</option>
                                        <option value="forest">🌲 Forêt</option>
                                    </select>
                                </div>
                            </div>
                        </div>

                        {/* Display Options */}
                        <div>
                            <h3 style={{ marginTop: 0, marginBottom: '1rem', fontSize: '1.1rem', color: 'var(--color-text)' }}>
                                ⚙️ Options d'affichage
                            </h3>
                            <div style={{ display: 'grid', gap: '1rem' }}>
                                {/* Show Weekends */}
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    cursor: 'pointer',
                                    padding: '12px',
                                    background: 'var(--color-background)',
                                    borderRadius: 'var(--border-radius-md)',
                                    border: '1px solid var(--color-light-gray)'
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={userPreferences.showWeekends}
                                        onChange={(e) => setUserPreferences({ ...userPreferences, showWeekends: e.target.checked })}
                                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                    />
                                    <span style={{ fontWeight: '500' }}>Afficher les week-ends</span>
                                </label>

                                {/* Compact Mode */}
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    cursor: 'pointer',
                                    padding: '12px',
                                    background: 'var(--color-background)',
                                    borderRadius: 'var(--border-radius-md)',
                                    border: '1px solid var(--color-light-gray)'
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={userPreferences.compactMode}
                                        onChange={(e) => setUserPreferences({ ...userPreferences, compactMode: e.target.checked })}
                                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                    />
                                    <span style={{ fontWeight: '500' }}>Mode compact (lignes plus petites)</span>
                                </label>

                                {/* Notifications */}
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    cursor: 'pointer',
                                    padding: '12px',
                                    background: 'var(--color-background)',
                                    borderRadius: 'var(--border-radius-md)',
                                    border: '1px solid var(--color-light-gray)'
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={userPreferences.notificationsEnabled}
                                        onChange={(e) => setUserPreferences({ ...userPreferences, notificationsEnabled: e.target.checked })}
                                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                    />
                                    <span style={{ fontWeight: '500' }}>Activer les notifications</span>
                                </label>

                                {/* Auto Refresh */}
                                <label style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    cursor: 'pointer',
                                    padding: '12px',
                                    background: 'var(--color-background)',
                                    borderRadius: 'var(--border-radius-md)',
                                    border: '1px solid var(--color-light-gray)'
                                }}>
                                    <input
                                        type="checkbox"
                                        checked={userPreferences.autoRefresh}
                                        onChange={(e) => setUserPreferences({ ...userPreferences, autoRefresh: e.target.checked })}
                                        style={{ width: '18px', height: '18px', cursor: 'pointer' }}
                                    />
                                    <span style={{ fontWeight: '500' }}>Actualisation automatique</span>
                                </label>

                                {/* Refresh Interval */}
                                {userPreferences.autoRefresh && (
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            marginBottom: '0.5rem',
                                            fontWeight: '600',
                                            fontSize: '0.9rem'
                                        }}>
                                            Intervalle d'actualisation (secondes)
                                        </label>
                                        <input
                                            type="number"
                                            min="10"
                                            max="300"
                                            step="10"
                                            value={userPreferences.refreshInterval}
                                            onChange={(e) => setUserPreferences({ ...userPreferences, refreshInterval: parseInt(e.target.value) })}
                                            style={{
                                                width: '100%',
                                                padding: '10px',
                                                border: '1px solid var(--color-light-gray)',
                                                borderRadius: 'var(--border-radius-md)',
                                                backgroundColor: 'var(--color-surface)',
                                                color: 'var(--color-text)'
                                            }}
                                        />
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div style={{
                    padding: '1rem 2rem 2rem',
                    borderTop: '1px solid var(--color-light-gray)',
                    display: 'flex',
                    gap: '1rem',
                    justifyContent: 'space-between'
                }}>
                    <button
                        onClick={resetPreferences}
                        style={{
                            padding: '12px 24px',
                            border: '1px solid #ef4444',
                            borderRadius: '8px',
                            background: 'transparent',
                            color: '#ef4444',
                            cursor: 'pointer',
                            fontWeight: '600',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        <FontAwesomeIcon icon={faTimes} />
                        Réinitialiser
                    </button>
                    <div style={{ display: 'flex', gap: '1rem' }}>
                        <button
                            onClick={() => setShowPreferences(false)}
                            style={{
                                padding: '12px 24px',
                                border: '1px solid var(--color-light-gray)',
                                borderRadius: '8px',
                                background: 'transparent',
                                color: 'var(--color-text)',
                                cursor: 'pointer',
                                fontWeight: '600'
                            }}
                        >
                            Annuler
                        </button>
                        <button
                            onClick={() => {
                                savePreferences(userPreferences);
                                setShowPreferences(false);
                            }}
                            style={{
                                padding: '12px 24px',
                                border: 'none',
                                borderRadius: '8px',
                                background: '#10b981',
                                color: 'white',
                                cursor: 'pointer',
                                fontWeight: '600',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '8px'
                            }}
                        >
                            <FontAwesomeIcon icon={faSave} />
                            Enregistrer
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TimesheetPreferencesModal;
